var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"back-top all-center",on:{"click":_vm.backTop}},[_c('img',{attrs:{"src":require("../assets/backTop.png"),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }